// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: "IBM Plex Mono", monospace;
}

.chat-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #0d0f12;
  color: #e2e8f0;
}

/* HEADER */
.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #1e2533;
  background: #0d0f12;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-icon {
  font-size: 20px;
  color: #38bdf8;
}

.header-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #f1f5f9;
}

.session-badge {
  font-size: 11px;
  background: #0f3460;
  color: #38bdf8;
  padding: 2px 8px;
  border-radius: 99px;
  letter-spacing: 0.3px;
}

.btn-icon {
  background: #1e2533;
  border: 1px solid #2d3748;
  color: #94a3b8;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.15s;
  font-family: inherit;
}

.btn-icon:hover {
  background: #2d3748;
  color: #e2e8f0;
}

.btn-icon:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* MESSAGES */
.messages-area {
  flex: 1;
  overflow-y: auto;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  scroll-behavior: smooth;
}

.messages-area::-webkit-scrollbar {
  width: 4px;
}

.messages-area::-webkit-scrollbar-thumb {
  background: #2d3748;
  border-radius: 4px;
}

/* WELCOME */
.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  gap: 12px;
  padding: 40px;
}

.welcome-icon {
  font-size: 48px;
  color: #38bdf8;
  opacity: 0.6;
}

.welcome h2 {
  font-size: 22px;
  font-weight: 600;
  color: #f1f5f9;
  margin: 0;
}

.welcome p {
  color: #64748b;
  margin: 0;
  font-size: 14px;
}

.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}

.suggestions button {
  background: #1e2533;
  border: 1px solid #2d3748;
  color: #94a3b8;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-family: inherit;
  transition: all 0.15s;
}

.suggestions button:hover {
  border-color: #38bdf8;
  color: #38bdf8;
}

/* ROWS */
.message-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.message-row.user {
  align-items: flex-end;
}

.message-row.assistant, .message-row.tool {
  align-items: flex-start;
}

/* BUBBLES */
.bubble {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.6;
}

.user-bubble {
  background: #1e3a5f;
  color: #e2e8f0;
  border-radius: 12px 12px 2px 12px;
}

.assistant-bubble {
  background: #141923;
  border: 1px solid #1e2533;
  border-radius: 2px 12px 12px 12px;
  position: relative;
}

.assistant-bubble.streaming .cursor {
  animation: blink 0.7s infinite;
  color: #38bdf8;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
/* THINKING */
.thinking-bubble {
  background: #141923;
  border: 1px solid #1e2533;
  border-radius: 2px 12px 12px 12px;
  display: flex;
  gap: 6px;
  align-items: center;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #38bdf8;
  animation: bounce 0.9s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.15s;
}

.dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}
/* TOOL CALL / RESULT */
.tool-call, .tool-result {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
  padding: 4px 0;
  flex-wrap: wrap;
}

.tool-call .tool-icon {
  color: #f59e0b;
}

.tool-result .tool-icon {
  color: #22c55e;
}

.tool-name {
  font-weight: 600;
  color: #94a3b8;
}

details {
  width: 100%;
}

summary {
  cursor: pointer;
  color: #475569;
  font-size: 11px;
}

pre {
  background: #0a0c0f;
  border: 1px solid #1e2533;
  border-radius: 6px;
  padding: 10px;
  font-size: 11px;
  overflow-x: auto;
  color: #64748b;
  max-height: 200px;
  overflow-y: auto;
  margin: 4px 0 0;
}

/* MARKDOWN */
.markdown-body {
  color: #cbd5e1;
}

.markdown-body :global(h1), .markdown-body :global(h2), .markdown-body :global(h3) {
  color: #f1f5f9;
  margin: 0.8em 0 0.4em;
}

.markdown-body :global(table) {
  border-collapse: collapse;
  width: 100%;
  margin: 0.8em 0;
  font-size: 13px;
}

.markdown-body :global(th) {
  background: #1e2533;
  color: #94a3b8;
  padding: 6px 10px;
  text-align: left;
}

.markdown-body :global(td) {
  padding: 6px 10px;
  border-bottom: 1px solid #1e2533;
}

.markdown-body :global(code) {
  background: #0a0c0f;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 12px;
  color: #38bdf8;
}

.markdown-body :global(strong) {
  color: #f1f5f9;
}

/* INPUT */
.input-area {
  padding: 12px 20px 16px;
  border-top: 1px solid #1e2533;
  background: #0d0f12;
}

.input-wrapper {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

textarea {
  flex: 1;
  background: #141923;
  border: 1px solid #2d3748;
  border-radius: 10px;
  color: #e2e8f0;
  padding: 10px 14px;
  font-family: inherit;
  font-size: 14px;
  resize: none;
  min-height: 44px;
  max-height: 140px;
  outline: none;
  transition: border-color 0.15s;
  line-height: 1.5;
}

textarea:focus {
  border-color: #38bdf8;
}

textarea:disabled {
  opacity: 0.4;
}

textarea::placeholder {
  color: #334155;
}

.send-btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: #38bdf8;
  color: #0d0f12;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.send-btn:hover {
  background: #7dd3fc;
}

.send-btn:disabled {
  background: #1e2533;
  color: #334155;
  cursor: not-allowed;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #0d0f12;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.input-hint {
  font-size: 11px;
  color: #334155;
  margin-top: 6px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/agent/agent-chat/agent-chat.component.scss"],"names":[],"mappings":"AAAA;EAAQ,aAAA;EAAe,sBAAA;EAAwB,YAAA;EAAc,uCAAA;AAK7D;;AAHA;EAAc,aAAA;EAAe,sBAAA;EAAwB,YAAA;EAAc,mBAAA;EAAqB,cAAA;AAWxF;;AATA,WAAA;AACA;EAAe,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EACjD,kBAAA;EAAoB,gCAAA;EAAkC,mBAAA;AAiBxD;;AAhBA;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAsBnD;;AArBA;EAAe,eAAA;EAAiB,cAAA;AA0BhC;;AAzBA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,qBAAA;EAAsB,cAAA;AAgCzE;;AA/BA;EAAiB,eAAA;EAAiB,mBAAA;EAAqB,cAAA;EACrD,gBAAA;EAAkB,mBAAA;EAAqB,qBAAA;AAuCzC;;AAtCA;EAAY,mBAAA;EAAqB,yBAAA;EAA2B,cAAA;EAC1D,iBAAA;EAAmB,kBAAA;EAAoB,eAAA;EAAiB,eAAA;EACxD,qBAAA;EAAsB,oBAAA;AAgDxB;;AA/CA;EAAkB,mBAAA;EAAqB,cAAA;AAoDvC;;AAnDA;EAAqB,YAAA;EAAa,mBAAA;AAwDlC;;AAtDA,aAAA;AACA;EAAiB,OAAA;EAAS,gBAAA;EAAkB,kBAAA;EAAoB,aAAA;EAC9D,sBAAA;EAAwB,SAAA;EAAW,uBAAA;AA+DrC;;AA9DA;EAAoC,UAAA;AAkEpC;;AAjEA;EAA0C,mBAAA;EAAqB,kBAAA;AAsE/D;;AApEA,YAAA;AACA;EAAW,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAChD,uBAAA;EAAyB,OAAA;EAAS,kBAAA;EAAoB,SAAA;EAAW,aAAA;AA8EnE;;AA7EA;EAAgB,eAAA;EAAiB,cAAA;EAAgB,YAAA;AAmFjD;;AAlFA;EAAc,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,SAAA;AAyFjE;;AAxFA;EAAa,cAAA;EAAgB,SAAA;EAAW,eAAA;AA8FxC;;AA7FA;EAAe,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,uBAAA;EAAyB,eAAA;AAqGlF;;AApGA;EAAsB,mBAAA;EAAqB,yBAAA;EAA2B,cAAA;EACpE,iBAAA;EAAmB,kBAAA;EAAoB,eAAA;EAAiB,eAAA;EACxD,oBAAA;EAAsB,qBAAA;AA8GxB;;AA7GA;EAA4B,qBAAA;EAAuB,cAAA;AAkHnD;;AAhHA,SAAA;AACA;EAAe,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAsHtD;;AArHA;EAAoB,qBAAA;AAyHpB;;AAxHA;EAA4C,uBAAA;AA4H5C;;AA1HA,YAAA;AACA;EAAU,cAAA;EAAgB,kBAAA;EAAoB,mBAAA;EAC5C,eAAA;EAAiB,gBAAA;AAiInB;;AAhIA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,iCAAA;AAsIpD;;AArIA;EAAoB,mBAAA;EAAqB,yBAAA;EACvC,iCAAA;EAAmC,kBAAA;AA2IrC;;AA1IA;EAAsC,8BAAA;EAA+B,cAAA;AA+IrE;;AA9IA;EAAmB;IAAQ,UAAA;EAmJzB;EAnJoC;IAAI,UAAA;EAsJxC;AACF;AArJA,aAAA;AACA;EAAmB,mBAAA;EAAqB,yBAAA;EACtC,iCAAA;EAAmC,aAAA;EAAe,QAAA;EAAU,mBAAA;AA4J9D;;AA3JA;EAAO,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,mBAAA;EAClD,+BAAA;AAkKF;;AAjKA;EAAoB,sBAAA;AAqKpB;;AApKA;EAAoB,qBAAA;AAwKpB;;AAvKA;EAAoB;IAAQ,wBAAA;EA4K1B;EA5KmD;IAAI,2BAAA;EA+KvD;AACF;AA9KA,uBAAA;AACA;EAA2B,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAC7D,eAAA;EAAiB,cAAA;EAAgB,cAAA;EAAgB,eAAA;AAsLnD;;AArLA;EAAwB,cAAA;AAyLxB;;AAxLA;EAA0B,cAAA;AA4L1B;;AA3LA;EAAa,gBAAA;EAAkB,cAAA;AAgM/B;;AA/LA;EAAU,WAAA;AAmMV;;AAlMA;EAAU,eAAA;EAAiB,cAAA;EAAgB,eAAA;AAwM3C;;AAvMA;EAAM,mBAAA;EAAqB,yBAAA;EAA2B,kBAAA;EACpD,aAAA;EAAe,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAClD,iBAAA;EAAmB,gBAAA;EAAkB,eAAA;AAkNvC;;AAhNA,aAAA;AACA;EAAiB,cAAA;AAoNjB;;AAnNA;EACE,cAAA;EAAgB,qBAAA;AAuNlB;;AAtNA;EAAgC,yBAAA;EAA2B,WAAA;EAAa,eAAA;EAAgB,eAAA;AA6NxF;;AA5NA;EAA6B,mBAAA;EAAqB,cAAA;EAAgB,iBAAA;EAAmB,gBAAA;AAmOrF;;AAlOA;EAA6B,iBAAA;EAAmB,gCAAA;AAuOhD;;AAtOA;EAA+B,mBAAA;EAAqB,gBAAA;EAAkB,kBAAA;EACpE,eAAA;EAAiB,cAAA;AA6OnB;;AA5OA;EAAiC,cAAA;AAgPjC;;AA9OA,UAAA;AACA;EAAc,uBAAA;EAAyB,6BAAA;EAA+B,mBAAA;AAoPtE;;AAnPA;EAAiB,aAAA;EAAe,QAAA;EAAU,qBAAA;AAyP1C;;AAxPA;EAAW,OAAA;EAAS,mBAAA;EAAqB,yBAAA;EAA2B,mBAAA;EAClE,cAAA;EAAgB,kBAAA;EAAoB,oBAAA;EAAsB,eAAA;EAC1D,YAAA;EAAc,gBAAA;EAAkB,iBAAA;EAAmB,aAAA;EACnD,8BAAA;EAA+B,gBAAA;AAsQjC;;AArQA;EAAiB,qBAAA;AAyQjB;;AAxQA;EAAoB,YAAA;AA4QpB;;AA3QA;EAAwB,cAAA;AA+QxB;;AA9QA;EAAY,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,YAAA;EAC1D,mBAAA;EAAqB,cAAA;EAAgB,eAAA;EAAiB,eAAA;EACtD,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EACpC,qBAAA;EAAsB,cAAA;AA2RxB;;AA1RA;EAAkB,mBAAA;AA8RlB;;AA7RA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,mBAAA;AAmS1D;;AAlSA;EAAW,WAAA;EAAa,YAAA;EAAc,yBAAA;EACpC,6BAAA;EAA+B,kBAAA;EAAoB,oCAAA;AA0SrD;;AAzSA;EAAkB;IAAK,yBAAA;EA8SrB;AACF;AA9SA;EAAc,eAAA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,kBAAA;AAoThE","sourcesContent":[":host { display: flex; flex-direction: column; height: 100%; font-family: 'IBM Plex Mono', monospace; }\n\n.chat-shell { display: flex; flex-direction: column; height: 100%; background: #0d0f12; color: #e2e8f0; }\n\n/* HEADER */\n.chat-header { display: flex; align-items: center; justify-content: space-between;\n  padding: 12px 20px; border-bottom: 1px solid #1e2533; background: #0d0f12; }\n.header-left { display: flex; align-items: center; gap: 10px; }\n.header-icon { font-size: 20px; color: #38bdf8; }\n.header-title { font-size: 15px; font-weight: 600; letter-spacing: .5px; color: #f1f5f9; }\n.session-badge { font-size: 11px; background: #0f3460; color: #38bdf8;\n  padding: 2px 8px; border-radius: 99px; letter-spacing: .3px; }\n.btn-icon { background: #1e2533; border: 1px solid #2d3748; color: #94a3b8;\n  padding: 6px 14px; border-radius: 6px; cursor: pointer; font-size: 12px;\n  transition: all .15s; font-family: inherit; }\n.btn-icon:hover { background: #2d3748; color: #e2e8f0; }\n.btn-icon:disabled { opacity: .4; cursor: not-allowed; }\n\n/* MESSAGES */\n.messages-area { flex: 1; overflow-y: auto; padding: 24px 20px; display: flex;\n  flex-direction: column; gap: 16px; scroll-behavior: smooth; }\n.messages-area::-webkit-scrollbar { width: 4px; }\n.messages-area::-webkit-scrollbar-thumb { background: #2d3748; border-radius: 4px; }\n\n/* WELCOME */\n.welcome { display: flex; flex-direction: column; align-items: center;\n  justify-content: center; flex: 1; text-align: center; gap: 12px; padding: 40px; }\n.welcome-icon { font-size: 48px; color: #38bdf8; opacity: .6; }\n.welcome h2 { font-size: 22px; font-weight: 600; color: #f1f5f9; margin: 0; }\n.welcome p { color: #64748b; margin: 0; font-size: 14px; }\n.suggestions { display: flex; flex-wrap: wrap; gap: 8px; justify-content: center; margin-top: 8px; }\n.suggestions button { background: #1e2533; border: 1px solid #2d3748; color: #94a3b8;\n  padding: 8px 14px; border-radius: 8px; cursor: pointer; font-size: 13px;\n  font-family: inherit; transition: all .15s; }\n.suggestions button:hover { border-color: #38bdf8; color: #38bdf8; }\n\n/* ROWS */\n.message-row { display: flex; flex-direction: column; gap: 4px; }\n.message-row.user { align-items: flex-end; }\n.message-row.assistant, .message-row.tool { align-items: flex-start; }\n\n/* BUBBLES */\n.bubble { max-width: 80%; padding: 12px 16px; border-radius: 12px;\n  font-size: 14px; line-height: 1.6; }\n.user-bubble { background: #1e3a5f; color: #e2e8f0; border-radius: 12px 12px 2px 12px; }\n.assistant-bubble { background: #141923; border: 1px solid #1e2533;\n  border-radius: 2px 12px 12px 12px; position: relative; }\n.assistant-bubble.streaming .cursor { animation: blink .7s infinite; color: #38bdf8; }\n@keyframes blink { 0%,100%{opacity:1} 50%{opacity:0} }\n\n/* THINKING */\n.thinking-bubble { background: #141923; border: 1px solid #1e2533;\n  border-radius: 2px 12px 12px 12px; display: flex; gap: 6px; align-items: center; }\n.dot { width: 6px; height: 6px; border-radius: 50%; background: #38bdf8;\n  animation: bounce .9s infinite; }\n.dot:nth-child(2) { animation-delay: .15s; }\n.dot:nth-child(3) { animation-delay: .3s; }\n@keyframes bounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-4px)} }\n\n/* TOOL CALL / RESULT */\n.tool-call, .tool-result { display: flex; align-items: center; gap: 8px;\n  font-size: 12px; color: #64748b; padding: 4px 0; flex-wrap: wrap; }\n.tool-call .tool-icon { color: #f59e0b; }\n.tool-result .tool-icon { color: #22c55e; }\n.tool-name { font-weight: 600; color: #94a3b8; }\ndetails { width: 100%; }\nsummary { cursor: pointer; color: #475569; font-size: 11px; }\npre { background: #0a0c0f; border: 1px solid #1e2533; border-radius: 6px;\n  padding: 10px; font-size: 11px; overflow-x: auto; color: #64748b;\n  max-height: 200px; overflow-y: auto; margin: 4px 0 0; }\n\n/* MARKDOWN */\n.markdown-body { color: #cbd5e1; }\n.markdown-body :global(h1), .markdown-body :global(h2), .markdown-body :global(h3)\n{ color: #f1f5f9; margin: .8em 0 .4em; }\n.markdown-body :global(table) { border-collapse: collapse; width: 100%; margin: .8em 0; font-size: 13px; }\n.markdown-body :global(th) { background: #1e2533; color: #94a3b8; padding: 6px 10px; text-align: left; }\n.markdown-body :global(td) { padding: 6px 10px; border-bottom: 1px solid #1e2533; }\n.markdown-body :global(code) { background: #0a0c0f; padding: 2px 5px; border-radius: 4px;\n  font-size: 12px; color: #38bdf8; }\n.markdown-body :global(strong) { color: #f1f5f9; }\n\n/* INPUT */\n.input-area { padding: 12px 20px 16px; border-top: 1px solid #1e2533; background: #0d0f12; }\n.input-wrapper { display: flex; gap: 8px; align-items: flex-end; }\ntextarea { flex: 1; background: #141923; border: 1px solid #2d3748; border-radius: 10px;\n  color: #e2e8f0; padding: 10px 14px; font-family: inherit; font-size: 14px;\n  resize: none; min-height: 44px; max-height: 140px; outline: none;\n  transition: border-color .15s; line-height: 1.5; }\ntextarea:focus { border-color: #38bdf8; }\ntextarea:disabled { opacity: .4; }\ntextarea::placeholder { color: #334155; }\n.send-btn { width: 40px; height: 40px; border-radius: 10px; border: none;\n  background: #38bdf8; color: #0d0f12; font-size: 18px; cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  transition: all .15s; flex-shrink: 0; }\n.send-btn:hover { background: #7dd3fc; }\n.send-btn:disabled { background: #1e2533; color: #334155; cursor: not-allowed; }\n.spinner { width: 16px; height: 16px; border: 2px solid #0d0f12;\n  border-top-color: transparent; border-radius: 50%; animation: spin .6s linear infinite; }\n@keyframes spin { to { transform: rotate(360deg); } }\n.input-hint { font-size: 11px; color: #334155; margin-top: 6px; text-align: center; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
